import {actionCreator} from '../redux/reduxUtil';

export const addError = actionCreator<{
  title: string;
  message: string;
}>('error.addError');
